import React from 'react';
import classes from './AddProductModal.module.css';
import Modal from '../../../components/UI/Modals/Modal';
import { ICartProduct } from '../../../store/slices/cart';
import { Stepper } from '../../../components/UI/Stepper/Stepper';

import { IProductDetail } from '../../../store/slices/productCategories';
import { ProductDetails } from '../../../components/ProductDetails/ProductDetails';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  product: IProductDetail;
  isOpen: boolean;
  onClose: () => void;
  editingCart?: ICartProduct;
  startStep?: number;
};

const ProductInformationModal: React.FC<Props> = ({
  product,
  isOpen,
  onClose,
  editingCart,
  startStep,
}) => {
  const { translations } = useTranslation();
  const [activeStep, setActiveStep] = React.useState<number>(startStep ?? 0);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={
        activeStep === 0
          ? translations('product.information').toString()
          : activeStep === 1
          ? translations('choose.appointment').toString()
          : translations('choose.language').toString()
      }
      divider
      containerPadding={'20px'}
      maxWidth={'850px'}
      width={'70%'}
    >
      <div className={classes.container}>
        {product.product_group !== 'H' && (
          <Stepper
            steps={
              product.product_group !== 'F' && product.product_group !== 'C'
                ? [{ displayText: translations('product.information').toString() }]
                : [{ displayText: translations('product.information').toString() }]
            }
            activeStep={activeStep}
            setActiveStep={setActiveStep}
          />
        )}
        <div className={classes.content}>
          {activeStep === 0 && (
            <ProductDetails
              product={product}
              //   onContinueClick={() => setActiveStep(activeStep + 1)}
              //   onCancelClick={() => onClose()}
            />
          )}
        </div>
        <div className={classes.buttonsContainer}></div>
      </div>
    </Modal>
  );
};

export { ProductInformationModal };
